// Predefined theme presets. The first one is free; the rest require Pro/Agency plan.
export const THEME_PRESETS = [
  {
    id: "classic",
    name: { de: "Klassisch", en: "Classic", tr: "Klasik" },
    description: { de: "Sauber und zeitlos", en: "Clean & timeless", tr: "Sade ve zamansız" },
    premium: false,
    theme: {
      primary_color: "#9333EA",
      accent_color: "#EC4899",
      background_color: "#FFFFFF",
      text_color: "#0F0F12",
      font_family: "Inter",
      layout: "list",
      button_style: "rounded",
      dark_mode: false,
    },
  },
  {
    id: "modern",
    name: { de: "Modern", en: "Modern", tr: "Modern" },
    description: { de: "Lebendig & jung", en: "Vivid & youthful", tr: "Canlı ve genç" },
    premium: true,
    theme: {
      primary_color: "#06B6D4",
      accent_color: "#8B5CF6",
      background_color: "#F8FAFC",
      text_color: "#0F172A",
      font_family: "Space Grotesk",
      layout: "cards",
      button_style: "pill",
      dark_mode: false,
    },
  },
  {
    id: "luxury",
    name: { de: "Luxus", en: "Luxury", tr: "Lüks" },
    description: { de: "Edel mit Gold-Akzenten", en: "Elegant with gold accents", tr: "Altın aksanlı zarif" },
    premium: true,
    theme: {
      primary_color: "#D4AF37",
      accent_color: "#B8860B",
      background_color: "#0B0B0F",
      text_color: "#F5F5F5",
      font_family: "Playfair Display",
      layout: "list",
      button_style: "sharp",
      dark_mode: true,
    },
  },
  {
    id: "cafe",
    name: { de: "Café", en: "Café", tr: "Kafe" },
    description: { de: "Warm und einladend", en: "Warm & inviting", tr: "Sıcak ve davetkar" },
    premium: true,
    theme: {
      primary_color: "#92400E",
      accent_color: "#D97706",
      background_color: "#FFF8F0",
      text_color: "#3C2415",
      font_family: "DM Sans",
      layout: "cards",
      button_style: "rounded",
      dark_mode: false,
    },
  },
  {
    id: "minimal",
    name: { de: "Minimal", en: "Minimal", tr: "Minimal" },
    description: { de: "Monochrom & reduziert", en: "Monochrome & minimal", tr: "Tek renkli ve minimal" },
    premium: true,
    theme: {
      primary_color: "#18181B",
      accent_color: "#52525B",
      background_color: "#FAFAFA",
      text_color: "#18181B",
      font_family: "Manrope",
      layout: "list",
      button_style: "sharp",
      dark_mode: false,
    },
  },
];
